import { render, staticRenderFns } from "./error-dialog.vue?vue&type=template&id=511e83cd&scoped=true&"
import script from "./error-dialog.vue?vue&type=script&lang=js&"
export * from "./error-dialog.vue?vue&type=script&lang=js&"
import style0 from "./error-dialog.vue?vue&type=style&index=0&id=511e83cd&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511e83cd",
  null
  
)

export default component.exports